<div class="brand-content" (click)="goHome()" title="{{brand()?.name}}">
  @if (isNotCollapsed()) {
  <div class="brand-logo-container">
    <img src="/assets/icons/logos/enacom_logo.png" alt="Gemminus Data Platform" class="brand-logo" />
  </div>
  } @else {
  <icon-induxtry [icon]="{ 
    icon: 'enacom_logo_mini', 
    width: 60,
    height: 40
  }"> </icon-induxtry>
  }
</div>